<template>
  <div>
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-lg-5 col-md-7 col-sm-9 col-xs-12 m-auto border rounded px-3 py-3 bg-light loginbox">

          <!-- FORMULARIO DE DNI -->
          <form @submit.prevent="registro()" v-if="!newCliente">
            <div class="row">
              <div class="col-md-12 text-center">
                <img :src="logoOscuro" class="mb-5"/>
              </div>
              <div class="col-md-12 form-group" v-if="error != ''">
                <p class="bg-danger text-light p-2 text-center rounded">{{ error }}</p>
              </div>
              <div class="col-md-12 form-group">
                <label>Introduzca su NIF para registrarse</label>
                <input type="text" v-model="nif" class="form-control"/>
              </div>
              <div class="col-md-12 form-group">
                <input type="checkbox" v-model="lopd" id="lopd" class="mr-1 align-center"/>
                <label for="lopd">Acepto la <a href="" @click.prevent="showPopup = true">política de protección de datos</a></label>
              </div>
              <div class="col-md-12 form-group text-right">
                <input v-if="!loading" type="submit" value="Registrarse" class="btn btn-primary"/>
                <button v-else class="btn btn-primary disabled" disabled>
                  <font-awesome-icon icon="spinner" class="fa-spin"/> Accediendo
                </button>
              </div>
            </div>
          </form>

          <!-- FORMULARIO DE NUEVO CLIENTE -->
          <form @submit.prevent="createCliente()" v-if="newCliente">
            <div class="row">
              <div class="col-md-12 text-center">
                <img :src="logoOscuro" class="mb-5"/>
              </div>
              <div class="col-md-12 text-center p-2 font-weight-bold">
                Sólo unos pocos datos más...
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Particular / Empresa</label>
                <select v-model="empresa" class="form-control">
                  <option :value="false">Particular</option>
                  <option :value="true">Empresa</option>
                </select>
              </div>
              <div class="col-md-6 form-group">
                <label v-if="empresa">CIF</label>
                <label v-if="!empresa">NIF/NIE</label>
                <input type="text" v-model="cliente.nif" class="form-control"/>
              </div>
              <div class="col-md-12 form-group" v-if="!empresa">
                <label>Nombre</label>
                <input type="text" v-model="cliente.nombre" class="form-control"/>
              </div>
              <div class="col-md-12 form-group" v-if="!empresa">
                <label>1<sup>er</sup> Apellido</label>
                <input type="text" v-model="cliente.apellido1" class="form-control"/>
              </div>
              <div class="col-md-12 form-group" v-if="!empresa">
                <label>2º Apellido</label>
                <input type="text" v-model="cliente.apellido2" class="form-control"/>
              </div>
              <div class="col-md-12 form-group" v-if="empresa">
                <label>Razón Social</label>
                <input type="text" v-model="cliente.apellido1" class="form-control"/>
              </div>
              <div class="col-md-6 form-group">
                <label>Teléfono Móvil</label>
                <input type="text" v-model="direccion.telefonoMovil" class="form-control"/>
              </div>
              <div class="col-md-6 form-group">
                <label>E-Mail</label>
                <input type="text" v-model="direccion.email" class="form-control"/>
              </div>
              <div class="col-md-12 form-group text-right">
                <input v-if="!loading" type="submit" value="Registrarse" class="btn btn-primary"/>
                <button v-else class="btn btn-primary disabled" disabled>
                  <font-awesome-icon icon="spinner" class="fa-spin"/> Accediendo
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <modal v-if="showPopup">
      <h5 slot="header" class="bg-primary text-light mb-0 p-2">Política de protección de datos</h5>
      <div slot="body">
        <strong>CLÁUSULA LOPD FACTURAS-PRESUPUESTOS</strong>

        <p class="caption">DATOS DE CARÁCTER PERSONAL: En cumplimiento de la Ley Orgánica 15/1999, de Protección de Datos de Carácter Personal,
        se le informa que sus datos serán incluidos en un fichero para su tratamiento propiedad de {{ nombreCorreduria }},
        cuya finalidad es la gestión fiscal, contable y administrativa de los clientes de la empresa, así como el contacto comercial.
        Tiene usted derecho de acceso, rectificación y cancelación, que podrá ejercer dirigiéndose a la siguiente dirección: {{ direccionCorreduria }}.</p>
        
        <strong><u>INFORMACIÓN CONTRATOS</u></strong> 
        
        <strong>TRATAMIENTO DE DATOS DE CARÁCTER PERSONAL</strong>

        <p class="caption">{{ nombreCorreduria }} se compromete, tanto durante la prestación de servicios a LA EMPRESA,
        como una vez extinguida la relación mercantil, al más estricto deber de confidencialidad y secreto respecto a toda la información
        que reciba como consecuencia de su prestación de servicios para el cliente y toda la información generada en los estudios
        realizados por el mismo. Igualmente, {{ nombreCorreduria }} se compromete, tanto en el desarrollo habitual de su cargo
        como fuera del mismo, a actuar con la debida cautela y lealtad para no dañar los intereses de LA EMPRESA.</p>

        <p class="caption">Una vez extiginda la relación, {{ nombreCorreduria }} no conservará ningún tipo de copia, extracto o reproducción
        de los documentos de los que haya tenido acceso, sea total o parcial, incluyendo los datos de carácter personal de LA EMPRESA
        (salvo por obligación legal).</p>

        <p class="caption">{{ nombreCorreduria }} no podrá disponer de los documentos o información de LA EMPRESA a que tenga acceso,
        con otro objeto que la prestación de sus servicios, salvo en caso de previa autorización expresa por escrito.</p>

        <p class="caption">{{ nombreCorreduria }} adoptará las medidas de índole técnica y organizativa necesarias para garantizar la seguridad
        de los datos personales suministrados, con el objetivo de evitar su alteración, pérdida, tratamientos o accesos no autorizados.
        Para ello aplicará las medidas de seguridad exigidas del Real Decreto 1720/2007 de nivel de seguridad adecuado al tipo de datos tratados,
        atendiendo a las condiciones descritas para los ficheros automatizados en la Sección 1ª (art. 89 a 94) del Capítulo III, y para los
        tratamiento no automatizados en la Sección 1ª (art. 105 a 108) del capítulo IV.</p>

        <p class="caption">En cumplimiento del artículo 5 de la LOPD, {{ nombreCorreduria }} le informa que sus datos están incorporados en un
        fichero creado por el Responsable del fichero, para la finalidad de gestión contable, de proveedores y de pagos, así como el contacto
        comercial por cualquier medio, incluido el correo electrónico. Sus datos van a ser tratados conforme a la Ley Orgánica 15/1999,
        de Protección de Datos. Podrá en cualquier momento ejercitar sus derechos de acceso, cancelación, rectificación y oposición en la
        dirección de la empresa.</p>
      </div>
      <div slot="footer">
        <button class="btn btn-danger mr-2" @click="negarLopd()">No acepto</button>
        <button class="btn btn-success" @click="aceptarLopd()">Acepto</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/widgets/Modal'
import util from '@/util'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      newCliente: false,
      error: '',
      nif: '',
      empresa: false,
      cliente: {
        nif: '',
        nombre: '',
        apellido1: '',
        apellido2: '',
        oficinas: [],
        entidad: 2
      },
      direccion: {
        telefonoMovil: '',
        email: '',
        principal: true
      },
      lopd: false,
      showPopup: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      nombreCorreduria: 'nombreCorreduria',
      direccionCorreduria: 'direccionCorreduria',
      urlBase: 'urlBase',
      logoOscuro: 'logoOscuro'
    })
  },
  methods: {
    registro() {
      if (!this.lopd) {
        alert("Debes aceptar la política de protección de datos para poder registrarte.")
        return
      }
      if (this.nif == '') {
        alert("Debes indicar tu NIF para poder registrarte.")
        return
      }
      this.loading = true
      let url = this.urlBase + 'clientesasurnet/web-clientes'
      let data = {
        nif: this.nif
      }
      let options = {}
      this.$http.post(url, data, options).then(
        (response) => {
          this.loading = false
          alert(response.body)
          this.$router.push({ name: 'login' })
        },
        (error) => {
          this.loading = false

          // No existe el cliente, creamos nuevo
          if (error.status == 404) {
            this.cliente.nif = this.nif
            this.newCliente = true
            console.log(error.body.error.message)
          } else {
            alert(error.body.error.message)
          }
        }
      );
    },
    createCliente() {
      if (this.cliente.nif.length < 8) {
        alert("El documento de identificación es necesario")
        return
      }
      if (this.cliente.nombre.length < 2 && !this.empresa) {
        alert("El nombre es necesario")
        return
      }
      if (this.cliente.apellido1.length < 2) {
        if (this.empresa) {
          alert("La razón social es necesaria")
        } else {
          alert("Los apellidos son necesarios")
        }
        return
      }
      if (!util.validateMovil(this.direccion.telefonoMovil)) {
        alert("El teléfono móvil es necesario")
        return
      }
      if (!util.validateEmail(this.direccion.email)) {
        alert("El e-mail es necesario")
        return
      }
      this.loading = true
      this.nif = this.cliente.nif
      this.cliente.entidad = (this.empresa) ? 1 : 2
      let url = this.urlBase + 'clientes/presunto'
      this.$http.post(url, this.cliente).then(
        (response) => {
          console.log(response)
          this.cliente = response.body
          this.saveDireccionCliente()
        },
        (error) => {
          this.loading = false
          alert(error.body.error.message)
        }
      )
    },
    saveDireccionCliente() {
      this.loading = true
      this.direccion.cliente = this.cliente.id
      let url = this.urlBase + 'direcciones/presunto'
      this.$http.post(url, this.direccion).then(
        (response) => {
          this.registro()
        },
        (error) => {
          this.loading = false
          alert(error.body.error.message)
        }
      )
    },
    aceptarLopd() {
      this.lopd = true
      this.showPopup = false
    },
    negarLopd() {
      this.lopd = false
      this.showPopup = false
    }
  },
  components: {
    Modal
  }
}
</script>

<style>

</style>
